export default {
    data() {
        return {
            pageLoading: false, // 全屏加载状态
            loading_text: '请稍候...',
            loading: false, // 表格加载状态
            multipleSelection: [],  // 复选框 已勾选数据
            page: 1, // 当前页
            page_size: 20, // 当前页多少条数据
            pageSizes: [10, 20, 50, 100], // 改变每页条数
            total: 0, // 总共多少条数据
            formSearchAndOperateBoxHeight: '50',    // 搜索框+操作行高度
        }
    },
    computed: {
        // 动态计算列表高度
        tableHeight() {
            // return `calc(100vh - 61px - - 200px - ${this.formSearchAndOperateBoxHeight}px)`
            return `${this.formSearchAndOperateBoxHeight}px`
        }
    },
    mounted() {
        this.initTableHeight()
        window.addEventListener('resize', this.initTableHeight)
    },
    methods: {
        initTableHeight() {
            this.$nextTick(() => {
                let manageDom = document.querySelector('.isManage')
                let manageDomHeight = (manageDom && manageDom.clientHeight) || 0
                let formDom = document.querySelector('.form-box')
                let formDomHeight = (formDom && formDom.clientHeight) || 0
                let paginationDom = document.querySelector('.pagination')
                let paginationHeight = (paginationDom && paginationDom.clientHeight) || 0
                this.formSearchAndOperateBoxHeight = manageDomHeight - formDomHeight - paginationHeight - 40
            })
        },
        // 复选框 已勾选数据
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        // 改变每页条数
        handleSizeChange(val) {
            this.page_size = val
            this.page = 1
            this.search()
        },
        // 跳转到第n页
        handleCurrentChange(val) {
            this.page = val
            this.search()
        },
        // 统一处理错误信息
        showErrorTip(res) {
            let msg = (res.data && res.data.errors && res.data.errors[0].message) || res.message || res.statusText || res.error_tip || (res.error && res.error[0].message)
            msg && this.$message.error(msg)
        },
    }
}
